import request from './_config'

const path = `ads`

export function createAd(tiktokAccountId, data) {
    return request({
        url: `${path}/${tiktokAccountId}`,
        method: 'post',
        data: {
            belong_to_atosa: data.belong_to_atosa,
            adgroup_id: data.adgroup_id,
            advertiser_id: data.advertiser_id,
            creatives: data.creatives
        }
    })
}

export function getAds(tiktokAccountId, params) {
    return request({
        url: `${path}/${tiktokAccountId}`,
        method: 'get',
        params: {
            advertiser_id: params.advertiser_id,
            filtering: params.filtering
        }
    })
}

export function updateAd(tiktokAccountId, data) {
    return request({
        url: `${path}/${tiktokAccountId}`,
        method: 'put',
        data: {
            ...data,
            advertiser_id: data.advertiser_id,
            adgroup_id: data.adgroup_id
        }
    })
}

export function updateAdStatus(tiktokAccountId, data) {
    return request({
        url: `${path}/status/${tiktokAccountId}`,
        method: 'post',
        data: {
            advertiser_id: data.advertiser_id,
            ad_ids: data.ad_ids,
            belong_to_atosa: data.belong_to_atosa,
            operation_status: data.operation_status
        }
    })
}
